import { ROUTES } from "~/router/routes";

interface ProviderSearchScenario {
  conditions: string[];
  state: string;
  office: string;
  groupName: string;
}

export const buildProviderSearchUrl = ({
  conditions,
  state,
  office,
  groupName,
}: ProviderSearchScenario): string => {
  const params = new URLSearchParams();
  conditions.forEach((condition) => params.append("conditions", condition));
  if (state) {
    params.set("state", state);
  }
  if (office) {
    params.set("office", office);
  }
  if (groupName) {
    params.set("group", groupName);
  }
  return `${ROUTES.adminProviderSearch}?${params.toString()}`;
};
